import React from 'react'; 
import '../styles/Footer.css';
import { FaTwitter, FaFacebookF, FaInstagram, FaWhatsapp, FaLinkedinIn } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="footer">
      {/* Redes Sociais */}
      <div className="footer-bottom">
        <p>&copy; LF DEVELOPER. Todos os Direitos Reservados</p>
        <div className="social-icons">
          <button onClick={() => alert('Redirecionando para Twitter')}><FaTwitter /></button>
          <button onClick={() => alert('Redirecionando para Facebook')}><FaFacebookF /></button>
          <button onClick={() => alert('Redirecionando para Instagram')}><FaInstagram /></button>
          <button onClick={() => alert('Redirecionando para WhatsApp')}><FaWhatsapp /></button>
          <button onClick={() => alert('Redirecionando para LinkedIn')}><FaLinkedinIn /></button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
